import React from 'react';
import Energy from './Energy';
import Range from './Range';
import Fluid from './Fluid';
import Tire from './Tire';

function TopStatistic(props) {
    return (
        <div className='topStatis'>
            <Energy/>
            <Range/>
            <Fluid/>
            <Tire/>
        </div>
    );
}

export default TopStatistic;